var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMageVideoPlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94531 7.43719H19.1695M14.5652 7.43719V2.71875M7.54959 7.43719V2.71875M9.34358 11.2669V15.9155C9.34358 16.0109 9.37306 16.1044 9.42743 16.1856C9.48271 16.2659 9.56103 16.331 9.65409 16.3735C9.74788 16.4156 9.8505 16.4327 9.95246 16.4233C10.0544 16.4139 10.1524 16.3783 10.2373 16.3197L13.7369 13.8169C13.8048 13.7685 13.8605 13.704 13.899 13.629C13.9353 13.5565 13.9527 13.4756 13.9495 13.3942C13.9463 13.3127 13.9225 13.2335 13.8806 13.1643C13.8353 13.0929 13.7748 13.0328 13.7037 12.9886L10.2042 10.8429C10.1186 10.7919 10.0221 10.7631 9.92324 10.759C9.82432 10.7548 9.72592 10.7755 9.63659 10.8193C9.55081 10.8617 9.47717 10.9261 9.42282 11.0063C9.37194 11.0832 9.34438 11.1739 9.34358 11.2669Z",
    stroke: "#70C7D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0518 2.59766H8.06263C5.00935 2.59766 2.53418 5.13471 2.53418 8.26432V14.4032C2.53418 17.5328 5.00935 20.0699 8.06263 20.0699H14.0518C17.1051 20.0699 19.5802 17.5328 19.5802 14.4032V8.26432C19.5802 5.13471 17.1051 2.59766 14.0518 2.59766Z",
    stroke: "#70C7D8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageVideoPlayer);
export default __webpack_public_path__ + "static/media/mage_video-player.3780dce491857022a773ea8656af858f.svg";
export { ForwardRef as ReactComponent };